import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['button', 'form', 'filter'];

  connect() {
    const url = new URL(window.location.href);
    if (url.searchParams.size > 0 && this.element.dataset.search === "false") {
      this.toggle();
    }
  }

  toggle() {
    if (this.hasFormTarget) {
      this.filterTargets.forEach((item) => {
        item.classList.toggle("hidden");
      });
      this.formTarget.classList.toggle("hidden");
      this.buttonTarget.classList.toggle("bg-gray-800");
      this.buttonTarget.classList.toggle("text-gray-50");
    }
  }

}